import { FunctionComponent, PropsWithChildren } from 'react';

import { Box } from '@mui/material';

import BasePaper from './components/base-paper';
import NavTabs from './components/tabs';
import WelcomeSection from './components/welcome-section';

const SearchLayout: FunctionComponent<PropsWithChildren> = ({ children }) => (
    <Box sx={{ maxWidth: '1516px', margin: '0 auto' }}>
        <WelcomeSection />

        <NavTabs>
            <BasePaper>{children}</BasePaper>
        </NavTabs>
    </Box>
);

export default SearchLayout;
